<template>
  <div class="d-flex">
    <v-tooltip
      v-for="({ count, color, icon, tooltip }, i) in counts"
      :key="i"
      top
      :disabled="!tooltip"
    >
      <template #activator="{ attrs, on }">
        <div class="pill mr-3" v-bind="attrs" v-on="on">
          <div class="icon" :class="color">
            <v-icon color="white" small>{{ icon }}</v-icon>
          </div>
          <div
            class="count caption grey lighten-4 px-2 grey--text text--darken-2 font-weight-bold"
          >
            {{ compactCount(count) }}
          </div>
        </div>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CountPills',
  props: {
    counts: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every((item) => {
          return (
            typeof item === 'object' &&
            typeof item.color === 'string' &&
            typeof item.count === 'number' &&
            typeof item.icon === 'string'
          );
        });
      },
    },
  },
  methods: {
    compactCount(count) {
      return Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1,
      })
        .format(count)
        .toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
$min-icon-width: 35px;
$min-count-width: 45px;
$pill-height: 22px;

.pill {
  display: grid;
  grid-template-columns: $min-icon-width minmax($min-count-width, 1fr);

  height: $pill-height;

  border-radius: $pill-height;

  overflow: hidden;

  .icon,
  .count {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
